import script from "./BaseSddsDropdownFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSddsDropdownFilter.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSddsDropdownFilter.vue?vue&type=style&index=0&id=3f7f4404&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7f4404"]])

export default __exports__